import { isArray } from '@/utils/validate'
import lodash from 'lodash'

export const ADD_ACTION = 0
export const REMOVE_ACTION = 1
export const UPDATE_ACTION = 2

export const ACTIONS = {
  ADD_ACTION, REMOVE_ACTION, UPDATE_ACTION
}

export default class AdvancedSearchField {
  _dropdownDataRef =null
  _dataCacheKey=null
  _valueExpression=null // 静态下拉数据对象{valueContent:[..._dataProvider],valueType:'static'}
  _dataProvider = null
  _action = ACTIONS.ADD_ACTION

  static ADD_ACTION = ACTIONS.ADD_ACTION
  static REMOVE_ACTION = ACTIONS.REMOVE_ACTION
  static UPDATE_ACTION = ACTIONS.UPDATE_ACTION
  // 注意：itemValue 请明确给定，即便为空，该类不做过多的类型场景处理
  constructor({ itemType = '', dropdownDataRef = null, changeEvent = null, action = ACTIONS.ADD_ACTION, lock = false, subType = '', type: dataProvider = null, fieldType = '', methodParams = {}, multiple = 0, operationType = '', itemCondition = [], defaultConditionVal = '', itemName = '', itemLabel = '', itemValue = '', defaultSelected = 0, selected = 0, cascade = null, headers = null, fields = null, url = null, tagName = null, tagValue = null, fixed = false, filterType = '', filterTagNames = [] } = {}) {
    this._itemType = itemType
    this._multiple = multiple
    this._operationType = operationType
    this._itemCondition = itemCondition
    this._defaultConditionVal = defaultConditionVal
    this._itemName = itemName
    this._cascade = cascade
    this._changeEvent = changeEvent
    this._itemLabel = itemLabel
    this._subType = subType
    this._itemValue = itemValue
    this._defaultValue = itemValue
    this._defaultSelected = defaultSelected
    this._selected = selected
    this._fieldType = fieldType
    this._methodParams = methodParams
    this.dropdownDataRef = dropdownDataRef
    this.dataProvider = dataProvider
    this.action = action
    this._lock = lock
    this._url = url // 不使用缓存数据时，才会生效
    this._headers = headers
    this._fields = fields
    this._tagName = tagName
    this._tagValue = tagValue
    this._fixed = fixed
    this._filterType = filterType
    this._filterTagNames = filterTagNames
  }

  get lock() {
    return !!this._lock
  }

  set lock(value) {
    this._lock = value
  }

  get action() {
    return this._action
  }

  set action(value) {
    this._action = value
  }

  getPropertyNames() {
    let names = Object.getOwnPropertyNames(Reflect.getPrototypeOf(this))
    names = names.filter(p => typeof this[p] !== 'function')
    return [...names]
  }

  formatObj2Json() {
    // todo 简洁写法{...this} 待测试
    const json = {}
    this.getPropertyNames().forEach(property => {
      // console.log('json[property]=this[property]', property, json[property], this[property])
      if (property !== 'dataProvider') {
        json[property] = this[property]
      }
    })
    return json
  }

  // todo 后续需要时扩展
  // static parseJson2Obj() {
  //   return new AdvancedSearchField()
  // }

  get dropdownDataRef() {
    return this._dropdownDataRef
  }

  set dropdownDataRef(value) {
    this._dropdownDataRef = value
    // todo 优化
    if (value) {
      this.dataCacheKey = `local_cache_${value.replace(/\./g, '$')}`
    }
  }

  get cascade() {
    return this._cascade
  }

  set cascade(value) {
    this._cascade = value
  }

  get dataCacheKey() {
    return this._dataCacheKey || ''
  }

  set dataCacheKey(value) {
    this._dataCacheKey = value
  }

  get dataProvider() {
    return this._dataProvider || null
  }

  set dataProvider(value) {
    this._dataProvider = value
    if (isArray(value) || Object.prototype.toString.call(value) === '[object Set]') {
      this.valueExpression = { valueContent: [...value], valueType: 'static' }
    }
  }
  get valueExpression() {
    return this._valueExpression || ''
  }

  set valueExpression(value) {
    this._valueExpression = value
  }

  get itemType() {
    return this._itemType || ''
  }

  set itemType(value) {
    this._itemType = value
  }

  get fieldType() {
    return this._fieldType || ''
  }

  set fieldType(value) {
    this._fieldType = value
  }

  get methodParams() {
    return this._methodParams || {}
  }

  set methodParams(value) {
    this._methodParams = value
  }

  get multiple() {
    return this._multiple || 0
  }

  set multiple(value) {
    this._multiple = value
  }

  get operationType() {
    return this._operationType || ''
  }

  set operationType(value) {
    this._operationType = value
  }

  get itemCondition() {
    return this._itemCondition || []
  }

  set itemCondition(value) {
    this._itemCondition = value
  }

  get defaultConditionVal() {
    return this._defaultConditionVal || ''
  }

  set defaultConditionVal(value) {
    this._defaultConditionVal = value
  }

  get itemName() {
    return this._itemName || ''
  }

  set itemName(value) {
    this._itemName = value
  }

  get changeEvent() {
    return this._changeEvent
  }

  set changeEvent(value) {
    this._changeEvent = value
  }

  get itemLabel() {
    return this._itemLabel || ''
  }

  set itemLabel(value) {
    this._itemLabel = value
  }

  get subType() {
    return this._subType || ''
  }

  set subType(value) {
    this._subType = value
  }

  get itemValue() {
    return this._itemValue
  }

  set itemValue(value) {
    if (Number(this.multiple) === 1) {
      this._itemValue = value || []
    } else {
      // 单选
      this._itemValue = (['number', 'boolean'].includes(typeof value)) ? value : (value || '')
    }
  }

  get defaultValue() {
    return this._defaultValue
  }

  set defaultValue(value) {
    let v = value
    if (typeof v === 'object') {
      v = lodash.cloneDeep(v)
    }
    if (Number(this.multiple) === 1) {
      this._defaultValue = v || []
    } else {
      // 单选
      this._defaultValue = (v || v === false || v === undefined) ? v : ''
    }
  }

  get defaultSelected() {
    return this._defaultSelected || 0
  }

  set defaultSelected(value) {
    this._defaultSelected = value
  }

  get selected() {
    return this._selected || 0
  }

  set selected(value) {
    this._selected = value
  }

  set headers(value) {
    this._headers = value
  }

  get headers() {
    return this._headers
  }

  set fields(value) {
    this._fields = value
  }

  get fields() {
    return this._fields
  }

  set url(value) {
    this._url = value
  }

  get url() {
    return this._url
  }

  set tagName(value) {
    this._tagName = value
  }

  get tagName() {
    return this._tagName
  }

  set tagValue(value) {
    this._tagValue = value
  }

  get tagValue() {
    return this._tagValue
  }

  set fixed(value) {
    this._fixed = value
  }

  get fixed() {
    return this._fixed
  }

  set filterType(value) {
    this._filterType = value
  }

  get filterType() {
    return this._filterType
  }

  set filterTagNames(value) {
    this._filterTagNames = value
  }

  get filterTagNames() {
    return this._filterTagNames || []
  }
}
